import { H1 } from 'platform-components';
import PropTypes from 'prop-types';
import React from 'react';

import ChangesNotification from 'common.components/changes-notification/changes-notification';
import { TeacherHeader } from 'common.components/TeacherHeader/TeacherHeader';
import PageContentTitle from 'common.components/page-content-title/page-content-title';

import Empty from './__empty/journal__empty';

import './journal.scss';

export class Journal extends React.Component {
    static propTypes = {
        savedOrFirstTeamId: PropTypes.number,
        getRouterPath: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
    };

    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    render() {
        return (
            <React.Fragment>
                <TeacherHeader />
                <ChangesNotification />
                <div className="journal">
                    <PageContentTitle title={<H1 id="header.link.journal" />} />
                    <Empty />
                </div>
            </React.Fragment>
        );
    }
}

export default Journal;
